import React from "react";
import TabContent from "./TabContent";
import styled from "styled-components";
import { Close } from '@mui/icons-material';
import { Paper, Box, Typography } from "@mui/material";
import TooltipIconButton from "components/TooltipIconButton";

const BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ActionGroups = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  &.MuiTypography-root {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #e5e5e5;
    font-family: "Roboto", sans-serif;
  }
`;
const Wrapper = styled(Paper)`
  &.MuiPaper-root {
    background-color: #2f2f2f;
  }
`;

const Content = (props) => {
  const { info, handleToggleModal } = props;

  return (
    <Wrapper square>
      <Box px="25px" pt="26px" pb="12px" width="100%">
        <BoxHeader>
          <Title>Catalog</Title>
          <ActionGroups>
            <TooltipIconButton title="Close" ariaLabel="close" placement="bottom" onClick={handleToggleModal} size={44}>
              <Close />
            </TooltipIconButton>
          </ActionGroups>
        </BoxHeader>
      </Box>
      <Box>
        {info && <TabContent tabInfo={info} />}
      </Box>
    </Wrapper>
  );
};

export default Content;